<template>
    <main id="main" class="ms-sm-auto">
        <div class="container">

            <div id="card-profile" class="card">
                <input type="checkbox" id="card-basic-info" class="card-input" checked="">

                <label class="card-header-label" for="card-basic-info">
                    <div class="card-title">{{ $t('basic_info') }}</div>
                    <div class="card-tools hide">
                        <!-- <button class="btn btn-card-header" @click="onSubmit" v-if="showSaveButton()">{{ $t('save') }}</button> -->
                        <!-- <button class="btn btn-card-header" @click="onSubmit" v-if="isShowSaveButton(user)">{{ $t('save') }}</button> -->
                    </div>
                </label>

                <div class="card-body hide">
                    <div class="profile-basic-content">
                        <div class="profile-basic-avatar">
                            <div class="profile-basic-avatar-info">
                                <div class="thumb">
                                    <div class="thumb-content">
                                        <img class="avatar" :src="user_info.avatar_url" v-if="user_info.avatar_url" />
                                        <!-- <img class="avatar" :src="user_info.avatar_url" alt=""> -->
                                        <img src="/themes/web/assets/images/avatar-default-2.svg" alt="" class="avatar" v-else>  
                                    </div>
                                </div>
                                <!-- <img class="emotion" v-if="child_account.emoji" :src="child_account.emoji" alt=""> -->
                                <img class="emotion" :src="user_info.emoji_url" alt="" v-show="user_info.emoji_url && user_info.student_type != 2"/>


                                <a href="#" class="upload" data-bs-toggle="modal" data-bs-target="#profileUploadModal">
                                    <i class="lisa-icon-profile-upload"></i>
                                </a>
                            </div>

                            <div class="row mb-15">
                                <div class="col-md-6 text-right">
                                    <span class="key">{{ $t('username') }}:</span>
                                </div>
                                <div class="col-md-6 text-left">
                                    <span class="val">{{user_info.username}}</span>
                                </div>
                            </div>
                            <div class="profile-basic-avatar-btn">
                                <a href="#" data-bs-toggle="modal" data-bs-target="#changePasswordModal">
                                    <button class="btn btn-change-password w100">
                                        <i class="lisa-icon-profile-lock"></i> {{$t("change_password")}}
                                    </button>
                                </a>
                            </div>
                            <div class="profile-basic-avatar-btn">
                                <a href="/connect-account-home" v-if="user.childrens">
                                    <button v-if="user.childrens.length < 2" class="btn btn-upgrade-account w100">
                                        <i class="lisa-icon-profile-upgrade"></i> {{$t("p_connect_account_btn")}}
                                    </button>
                                </a>
                                <a href="/connect-account-home" v-else>
                                    <button class="btn btn-upgrade-account w100">
                                        <i class="lisa-icon-profile-upgrade"></i> {{$t("p_connect_account_btn")}}
                                    </button>
                                </a>
                            </div>
                            <div class="profile-basic-avatar-btn">
                                <button class="btn save-parent" @click="onSubmit" v-if="show ? isShowSaveButton(user): show">{{ $t('save') }}</button>
                            </div>

                            <!-- <div class="profile-basic-avatar-btn">
                                <a href="#" @click="onSubmit" v-if="showSaveButton()">
                                    <button class="btn btn-profile-save w100">{{$t('save')}}</button>
                                </a>
                            </div> -->
                        </div>
                        <div class="profile-basic-info">

                            <form action="#">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="profile-fullname" class="form-label">{{$t('full_name')}}</label>
                                        <input type="text" class="form-control" v-model="user.fullname"
                                               :placeholder="$t('full_name')" autocomplete="off">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="profile-birthday" class="form-label">{{ $t('birthday') }}</label>
                                        <div class="form-control-calander">
                                            <input type="text" class="form-control datepicker"
                                                   :placeholder="$t('birthday')" autocomplete="off" v-model="user.birthday">
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <label for="profile-relationship" class="form-label">{{ $t('relationship') }}</label>
                                        <div class="select-wrapper">
                                            <select name="relationship" id="profile-relationship" class="form-control" v-model="user.relationship">
                                                <option value="">{{ $t('choose_relationship') }}</option>
                                                <option value="father">{{ $t('father') }}</option>
                                                <option value="mother">{{ $t('mother') }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="profile-grade" class="form-label">{{ $t('p_no_of_children') }}</label>
                                        <input type="text" class="form-control" disabled=""
                                               placeholder="No. of children" :value="user.childrens?user.childrens.length:0" autocomplete="off">
                                    </div>
                                    <div class="col-md-6">
                                        <label for="profile-class" class="form-label">{{ $t('phone') }}</label>
                                        <input type="number" class="form-control"
                                               :placeholder="$t('phone')" v-model="user.phone" autocomplete="off">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="profile-fullname" class="form-label">{{ $t('email') }}</label>
                                        <input type="text" class="form-control"
                                               :placeholder="$t('email')" autocomplete="off" v-model="user.email">
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>

            <div class="card" v-if="child_account">
                <input type="checkbox" id="card-contact-detail" class="card-input">

                <label class="card-header-label" for="card-contact-detail">
                    <div class="card-title">{{$t('lisa_web_children_informations')}}</div>
                </label>

                <div class="card-body hide">
                    <div class="profile-basic-content">
                        <div class="profile-basic-avatar">
                            <div class="profile-basic-avatar-info">
                                <div class="thumb">
                                    <div class="thumb-content">
                                        <img class="avatar" :src="child_account.avatar_url" alt="" v-if="child_account.avatar_url"/>
                                        <img src="/themes/web/assets/images/avatar-default-2.svg" alt="" class="avatar" v-else>                                        
                                    </div>
                                </div>

                                <img class="emotion" v-if="child_account.emoji" :src="child_account.emoji" alt="">
                            </div>

                            <div class="row mb-15">
                                <div class="col-md-6 text-right">
                                    <span class="key">{{ $t('username') }}:</span>
                                </div>
                                <div class="col-md-6 text-left">
                                    <span class="val">{{child_account.username}}</span>
                                </div>
                            </div>
                            <div class="row mb-15">
                                <div class="col-md-6 text-right">
                                    <span class="key">{{ $t('p_key_account') }}:</span>
                                </div>
                                <div class="col-md-6 text-left">
                                    <span class="val">{{child_account.key_child}}</span>
                                </div>
                            </div>
                            <div class="profile-basic-avatar-btn">
                                <a href="#" @click = "showRemoveChildrentAccount(child_account)">
                                    <button class="btn btn-profile-remove-account w100">{{ $t('p_remove_account_btn') }}</button>
                                </a>
                            </div>
                        </div>
                        <div class="profile-basic-info">

                            <form action="#">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="profile-fullname" class="form-label">{{$t('full_name')}}</label>
                                        <input type="text" class="form-control" id="profile-fullname"
                                               placeholder="Fullname" disabled="" autocomplete="off" :value="child_account.fullname">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="profile-birthday" class="form-label">{{ $t('birthday') }}</label>
                                        <div class="form-control-calander">
                                            <input type="text" class="form-control datepicker hasDatepicker"
                                                   id="profile-birthday" placeholder="Birthday" disabled=""
                                                   autocomplete="off" :value="child_account.birthday">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="profile-gender" class="form-label">{{ $t('gender') }}</label>
                                        <div class="select-wrapper">
                                            <select name="gender" id="profile-gender-1" class="form-control"
                                                    disabled="">
                                                <option value="1" :selected="child_account.gender == 'male'">{{$t('male')}}</option>
                                                <option value="2" :selected="child_account.gender == 'female'">{{ $t('female') }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="profile-grade" class="form-label">{{$t('grade')}}</label>
                                        <input type="text" class="form-control" id="profile-grade" disabled=""
                                               placeholder="No. of children" autocomplete="off" :value="child_account.grade">
                                    </div>
                                    <div class="col-md-6">
                                        <label for="profile-class" class="form-label">{{$t('phone')}}</label>
                                        <input type="text" class="form-control" id="profile-class"
                                               placeholder="Phone number" disabled :value="child_account.phone"
                                               autocomplete="off">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="profile-fullname" class="form-label">Email</label>
                                        <input type="text" class="form-control" id=""
                                               placeholder="Email" disabled="" autocomplete="off" :value="child_account.email">
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>

            <div class="modal modal-flex fade" id="cropAvatarModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="cropAvatarModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 475px; max-width: 475px;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">{{$t('edit_image')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="avatar-edit-form">
                                <img id="image-crop" :src="avatar_crop_data" alt="">
                            </div>
                        </div>
                        <div class="modal-footer" style="justify-content: center;">
                            <button type="button" id="image-choose-img" class="btn btn-choose-image choose-image-other" @click="chooseImage" style="padding: 10px 30px;">{{$t('choose_image')}}</button>
                            <button type="button" id="image-crop-save" class="btn btn-main-sm" style="padding: 10px 30px;" @click="cropSave">{{ $t('save') }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal modal-flex" id="profileUploadModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="profileUploadModal" aria-hidden="true">
                <div class="modal-dialog popup" style="width: 576px; max-width: 576px;">
                    <div class="modal-content">
                        <div class="modal-body pd0">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                            <div class="profile-modal-content">
                                <div class="profile-modal-content-left">
                                    <h4 class="title">{{$t('student_profile')}}</h4>

                                    <div class="profile-basic-avatar">
                                        <div class="profile-basic-avatar-info">
                                            <div class="thumb">
                                                <div class="thumb-content">
                                                    <img class="avatar" ref="avatar_url" :src="user_info.avatar_url?user_info.avatar_url:'/themes/web/assets/images/avatar-default.svg'" alt="" />
                                                </div>
                                            </div>

                                            <a href="#" class="upload" data-bs-toggle="modal" data-bs-target="#profileUploadModal">
                                                <i class="lisa-icon-profile-upload"></i>
                                            </a>
                                            <!-- <img ref="emoticon_url" :class="!user.emoji_url ? 'emotion hide' : 'emotion'" :src="user.emoji_url" alt=""/> -->
                                            <img ref="emoticon_url" :class="!user.emoji_url ? 'emotion hide' : 'emotion'" :src="user.emoji_url" alt=""/>
                                        </div>
                                    </div>

                                    <div>
                                        <button class="btn btn-main btn-save" :disabled="disable_button_update_avatar" @click="updateAvatar">{{ $t('save') }}</button>
                                    </div>
                                </div>
                                <div class="profile-modal-content-right">

                                    <nav>
                                        <div class="nav nav-tabs" role="tablist">
                                            <button class="nav-link active" id="nav-avatar-tab" data-bs-toggle="tab" data-bs-target="#nav-avatar" type="button" role="tab" aria-controls="nav-home" aria-selected="true">{{$t('avatar')}}</button>
                                            <button class="nav-link" id="nav-emoticon-tab" data-bs-toggle="tab" data-bs-target="#nav-emoticon" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">{{$t('sticker')}}</button>
                                        </div>
                                    </nav>
                                    <div class="tab-content">
                                        <div class="tab-pane fade show active" id="nav-avatar" role="tabpanel" aria-labelledby="nav-avatar-tab">
                                            <div class="avatars nano">
                                                <div class="nano-content">
                                                    <div class="avatar-items list-avatars">
                                                        <div class="row">
                                                            <!-- <div class="col-md-3">
                                                                <div class="avatar-item-upload">
                                                                    <label for="avatar-item-upload">
                                                                        <i class="lisa-icon-profile-upload-1"></i>
                                                                        Upload
                                                                    </label>

                                                                    <input type="file" id="avatar-item-upload" name="avatar" accept="image/*" @change="addEvent"/>
                                                                </div>
                                                            </div> -->

                                                            <div class="col-md-3" v-for="(avatar, index) in avatars" @click="selectAvatar(avatar)" v-bind:key="index">
                                                                <div :class="avatar.id  == user.avatar_id?'avatar-item active':'avatar-item'">
                                                                    <div class="thumb">
                                                                        <div class="thumb-content">
                                                                            <img class="thumb-img br8" :src="avatar.url" alt="" />
                                                                        </div>
                                                                    </div>

                                                                    <div class="gem-info" v-if="avatar.price > 0">
                                                                        {{ avatar.price }} <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="nav-emoticon" role="tabpanel" aria-labelledby="nav-emoticon-tab">
                                            <div class="avatars nano">
                                                <div class="nano-content">
                                                    <div class="avatar-items list-emoticons">
                                                        <div class="row">
                                                            <div class="col-md-3" v-for="(emoticon) in emoticons" @click="selectEmoticon(emoticon)" :key="emoticon.id">
                                                                <div :class="emoticon.id  == user.emoji_id?'avatar-item active':'avatar-item'">
                                                                    <div class="thumb">
                                                                        <div class="thumb-content">
                                                                            <img class="thumb-img-emoticon" :src="emoticon.url" alt="" />
                                                                        </div>
                                                                    </div>

                                                                    <div class="gem-info" v-if="avatar.price > 0">
                                                                        {{ avatar.price }} <AppIcon :src="$store.state.configs.default_gem_icon" :size="15" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal modal-flex fade" id="changePasswordModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="changePasswordModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 500px; max-width: 500px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title">{{$t('change_password') }}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="change-password-form">
                                <div class="mb-12">{{$t('current_password') }}</div>

                                <div class="form-control-password">
                                    <input :type="showPass ? 'text' : 'password'" :class="errors.current_password?'form-control has-error':'form-control'"
                                           name="current_password"
                                           :placeholder="$t('placeholder_current_password')" v-model="current_password">
                                    <i :class="[showPass ? 'lisa-icon-eye-1' : 'lisa-icon-eye-2']" @click="showPass = !showPass"></i>
                                </div>
                                <div class="form-control-password">
                                    <input :type="showNewPass ? 'text' : 'password'" class="form-control"
                                           name="new_password"
                                           :placeholder="$t('placeholder_new_password')" v-model="new_password">
                                    <i :class="[showNewPass ? 'lisa-icon-eye-1' : 'lisa-icon-eye-2']" @click="showNewPass = !showNewPass"></i>
                                </div>
                                <div class="password-strength">
                                    <div :class="strength > 0?'password-strength-item red':'password-strength-item'"></div>
                                    <div :class="strength > 1?'password-strength-item red':'password-strength-item'"></div>
                                    <div :class="strength > 2?'password-strength-item red':'password-strength-item'"></div>
                                </div>
                                <div class="password-strength-txt">{{$t('lisa_web_password_strength')}}: {{textStrength}}</div>
                                <div class="form-control-password">
                                    <input :type="showConfirmPass ? 'text' : 'password'" :class="errors.confirm_password?'form-control has-error':'form-control'"
                                           name="confirm_password"
                                           :placeholder="$t('placeholder_confirm_password')" v-model="confirm_password">
                                    <i :class="[showConfirmPass ? 'lisa-icon-eye-1' : 'lisa-icon-eye-2']" @click="showConfirmPass = !showConfirmPass"></i>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-main-border m-auto" :disabled = "current_password == '' || new_password == '' || confirm_password == ''" style="padding: 8px 40px;" @click="changeNewPass()">
                                {{ $t('save') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="formErrorModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 360px; max-width: 360px;margin-top: 145px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title text-red">{{$t(`${error}`)}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div>{{$t(`${error_message}`)}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal modal-flex fade" id="formSuccessModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 365px; max-width: 365px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title">{{$t('password_updated')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="welcome-back">
                                <img src="/themes/web/assets/images/modal-image-success.svg" alt="" />

                                <div class="welcome-back-content">
                                    {{$t('password_has_been_updated_successfully')}}
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-main-border m-auto" data-bs-dismiss="modal" aria-label="Close" style="padding: 8px 20px;">Next</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="uploadErrorModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="formErrorModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 450px; max-width: 450px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title">{{$t(`${error}`)}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="welcome-back">
                                <img src="/themes/web/assets/images/icon-error.svg" alt="" />

                                <div class="welcome-back-content">
                                    {{$t('lisa_web_error_img_size')}}
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" id="choose-image-other" class="btn btn-main-border m-auto" style="padding: 8px 20px;">{{$t('choose_img')}}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade modal-flex" id="removeChildAccountModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="removeAccountModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 360px; max-width: 360px;">
                    <div class="modal-content popup-confirm" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title text-red" id="staticBackdropLabel">{{$t('p_remove_child_title')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="welcome-back">
                                <div class="welcome-back-content">
                                    {{$t('lisa_web_remove_children_account_confirm', {account_name: account_selecting_remove.fullname?account_selecting_remove.fullname:account_selecting_remove.username})}}
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer" style="justify-content: center;">
                            <button type="button" class="btn btn-confirm-no" style="padding: 8px 20px;" data-bs-dismiss="modal" aria-label="Close">{{$t('no')}}</button>
                            <button type="button" class="btn btn-confirm" style="padding: 8px 20px;" @click="removeChildrentAccount(account_selecting_remove)">{{$t('yes')}}</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </main>
</template>

<script>
    import axios from "axios";
    import { getAvatars, updateAvatar, updateProfile, updateContact, updateParentProfile,updateAvatarParent } from '../../models/profile'
    import { getCountries, getProvinces, getWards } from '../../models/config'
    import { changeNewPassword } from '../../models/auth'
    import { getConfigs, getLanguage, soundClick } from "../../utils/utils";
    import {getParentProfile} from '../../models/profile'
    import {removeChild} from '../../models/parent'
    import 'cropperjs/dist/cropper.css';
    import Cropper from 'cropperjs';
    import AppIcon from "@/components/common/AppIcon.vue";

    export default {
        name: "ParentProfile",
        title: 'Parents - Profile',
        components: {
            AppIcon
        },

        data() {
            const user_info = this.$store.state.user_info;

            let child_account = localStorage.getItem('child_account');

            child_account = child_account?JSON.parse(child_account):null;

            if(child_account == null && user_info.childrens){
                child_account = user_info.childrens[0];
            }

            return {
                error: '',
                profile: '',
                child_account: child_account,
                errors: {
                    address: '',
                    fullname: '',
                    current_password: '',
                    new_password: '',
                    confirm_password: '',
                },
                // user: user_info,
                user: {
                    id: '',
                    emoji_id: 0,
                    extension_file: 'png',
                    avatar_id: -1,
                    avatar_img: '',
                    fullname: '',
                    birthday: '',
                    account_type: '',
                    email: '',
                    relationship: '',
                    avatar_url: '',
                    user_name: '',
                    expired_date: '',
                    language_active: '',
                    childrens: '',
                    phone: '',
                },
                countries: [],
                provinces: [],
                wards: [],
                showPass: false,
                showNewPass: false,
                showConfirmPass: false,
                avatar: '',
                avatars: [],
                emoticons: [],
                current_password: '',
                new_password: '',
                confirm_password: '',
                strength: 0,
                classStrength: '',
                textStrength: 'Weak',
                avatar_crop_data: '',
                disable_button_update_avatar: true,
                cropper: null,
                error_message: '',
                is_valid: true,
                account_selecting_remove: {},
                key_change_info: '',
                show: false,
            };
        },

        computed: {
            // user_info() {
            //     return this.getUserInfo();
            // },
            user_info() {
                return this.$store.state.user_info
            }
        },

        mounted () {
            setTimeout(e => {
                this.show=true
            },500)
        },

        watch: {
            'new_password': function(newVal, oldVal) {
                if (newVal == this.current_password) {
                    this.errors.new_password = "New password cannot be  the same as the current password.";
                } else if (newVal == this.user.user_name) {
                    this.errors.new_password = "New password cannot be  the same as the username.";
                } else {
                    this.errors.new_password = "";
                }
                this.strengPassword(newVal);
            },
            'strength': function(newVal, oldVal) {
                if (newVal == 1) {
                    this.classStrength = 'pw-weak';
                    this.textStrength = 'Weak';
                } else if (newVal == 2) {
                    this.classStrength = 'pw-normal';
                    this.textStrength = 'Good';
                } else if (newVal == 3) {
                    this.classStrength = 'pw-strong';
                    this.textStrength = 'Strong';
                } else {
                    this.classStrength = '';
                    this.textStrength = '';
                }
            },
            'confirm_password': function(newVal, oldVal) {
                this.errors.confirm_password = (newVal != this.new_password) ? 'Confirm password does not match.' : '';
            }
        },

        created() {
            this.fetch();
            this.$store.commit("setMenuActive", "parent_profile");
        },
        // methods: {
        //     fetch(){
        //         axios.all([
        //             getParentProfile({
        //                 notification_id: window.localStorage.getItem('firebaseToken'),
        //                 type_code: 'web'
        //             })
        //         ]).then(axios.spread(({data}) => {
        //             this.$store.commit("setLoading", false);
        //
        //             const profile = data.results;
        //
        //             profile.avatar_url = profile.avatar_url || '/themes/web/assets/images/avatar-default-2.svg';
        //
        //         })).catch(error => {
        //             console.log(error)
        //
        //         });
        //     },
        // },
        methods: {
            isShowSaveButton(user){
                return this.key_change_info != this.getKeyChangeInfo(user);
            },
            getKeyChangeInfo(user){
                return user.fullname+
                '|'+user.birthday+
                '|'+user.relationship+
                '|'+user.phone+
                '|'+user.email;
            },
            async fetch() {
                const that = this;
                this.key_change_info = this.getKeyChangeInfo(this.user);

                const user = this.$store.state.user_info;
                console.log('parent: ',user);
                this.user.id = user.id;
                this.user.fullname = user.fullname;
                this.user.birthday = user.birthday;
                this.user.relationship = user.relationship;
                this.user.account_type = user.account_type;
                this.user.avatar_url = user.avatar_url;
                this.user.avatar_id = user.avatar_id;
                this.user.emoji_id = user.emoji_id;
                this.user.emoji_url = user.emoji_url;
                this.user.avatar_img = user.avatar_url;
                this.user.user_name = user.username;
                this.user.account_type = user.account_type;
                this.user.email = user.email;
                this.user.childrens = user.childrens;
                this.user.phone = user.phone?user.phone:'';
                this.user.expired_date = moment(user.expired_date).format('DD/MM/YYYY');

                await axios.all([
                    getAvatars(),
                    // getCountries(),
                    // getProvinces({
                    //     country_id: that.user_info.contact_user.country_id
                    // }),
                    // getWards({
                    //     province_id: that.user_info.contact_user.city_id
                    // }),
                ]).then(axios.spread((response, response_countries, response_provinces, response_wards) => {
                    if (response.data.code != 0) {
                        return;
                    }

                    const items = response.data.results.items || [];

                    items.forEach(function(item) {
                        if (item.type == 0) {
                            that.avatars.push(item)
                        }
                        if (item.type == 1) {
                            that.emoticons.push(item)
                        }
                    });

                    that.key_change_info = that.getKeyChangeInfo(that.user_info);
                    // that.countries = response_countries.data.results || [];
                    // that.provinces = response_provinces.data.results || [];
                    // that.wards = response_wards.data.results || [];
                }));

                this.$nextTick(function() {
                    $('.datepicker').datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showOtherMonths: true,
                        selectOtherMonths: false,
                        yearRange: '1900:+0',
                        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                        onSelect: function(dateText) {
                            //console.log("Selected date: " + dateText + "; input's current value: " + this.value);

                            that.user.birthday = this.value;
                        }                        
                    });

                    var initNanoScroller = function() {
                        if ($('.nano').length > 0) {
                            $(".nano").nanoScroller();
                        }
                    }

                    $('button[data-bs-toggle="tab"]').on('show.bs.tab', function(e) {
                        initNanoScroller();
                    });
                    $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function(e) {
                        initNanoScroller();
                    });
                    $('#profileUploadModal').on('shown.bs.modal', function() {
                        initNanoScroller();
                    });

                    initNanoScroller();
                })
            },

            changeDateEvent({target}) {
                console.log(target.value)
            },

            getUserInfo(){
                const user_info = this.$store.state.user_info;

                user_info.birthday = user_info.birthday.replace(' 00:00:00 +0700 +07', '');
                //user_info.birthday = user_info.birthday?moment(user_info.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY'):null;

                return user_info;                
            },

            showSaveButton(){
                return this.user_info.fullname != this.user.fullname
                    || this.user_info.birthday != this.user.birthday
                    || this.user_info.relationship != this.user.relationship
                    || this.user_info.email != this.user.email
                    || this.user_info.phone != this.user.phone;
            },

            showError(message) {
                this.error_message = message;

                $('.modal').modal('hide');

                $('#formErrorModal').modal('show');
            },

            chooseImage() {
                if (this.cropper != null) {
                    this.cropper.destroy();
                }

                $('#avatar-item-upload').click();
                $('.modal').modal('hide');
            },

            cropSave() {
                const that = this;

                that.$store.commit("setLoading", true);

                const croppedImageDataURL = that.cropper.getCroppedCanvas().toDataURL("image/png");

                updateAvatarParent({
                    avatar_id: -1,
                    avatar_img: croppedImageDataURL,
                    emoji_id: 0,
                    type: 0,
                    extension_file: 'png',
                }).then((response) => {
                    that.$store.commit("setLoading", false);

                    $('#cropAvatarModal').modal('hide');

                    that.cropper.destroy();

                    //console.log(response)

                    if (response.data.code != 0) {
                        that.showError(response.data.msg)

                        return;
                    }

                    const time = new Date().getTime();

                    that.user_info.avatar_id = response.data.results.avatar_id;
                    that.user_info.avatar_url = response.data.results.avatar_url + '?v=' + time;
                }).catch((response) => {
                    that.$store.commit("setLoading", false);

                    $('#cropAvatarModal').modal('hide');

                    that.cropper.destroy();

                    //console.error(response)
                });
            },

            cropeChange({ coordinates, canvas }) {
                if (coordinates.height == 0) {
                    return;
                }

                this.avatar_crop_data = canvas.toDataURL("image/png");
            },

            searchEvent({ target }) {
                this.user[target.name] = target.value;
            },

            showRemoveChildrentAccount(account){
                this.account_selecting_remove = account;

                $('#removeChildAccountModal').modal('show');
            },

            removeChildrentAccount(account) {
                const that = this;

                removeChild({
                    children_id: account.id,
                    parent_id: this.user.id,
                }).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }

                    $('#removeAccountModal').modal('hide');

                    localStorage.removeItem('child_account');

                    location.reload();
                }).catch((response) => {
                    that.$store.commit("setLoading", false);

                    console.error(response)
                });                
            },

            addEvent({ target }) {
                const that = this;

                switch (target.name) {
                    // case 'profile_country':
                    //     getProvinces({
                    //         country_id: that.user_info.contact_user.country_id
                    //     }).then((response) => {
                    //         if (response.data.code != 0) {
                    //             return;
                    //         }
                    //         that.provinces = response.data.results || [];
                    //     });
                    //
                    //     break;
                    // case 'profile_province':
                    //     getWards({
                    //         province_id: that.user_info.contact_user.city_id
                    //     }).then((response) => {
                    //         if (response.data.code != 0) {
                    //             return;
                    //         }
                    //         that.wards = response.data.results || [];
                    //     });
                    //
                    //     break;
                    case 'avatar':
                        const reader = new FileReader();

                        const images = target.files;

                        if (images.length == 0) {
                            break;
                        }

                        const image = images[0];

                        that.avatar = image;

                        //console.log(image.name)

                        reader.onload = function(e) {
                            //that.user.avatar_id = -1;
                            //that.user.avatar_img = e.target.result;
                            //that.user.extension_file = image.name.split('.').pop();

                            that.avatar_crop_data = e.target.result;

                            //console.log(that.avatar_crop_data)
                            //that.avatar_crop_data = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAAQABAAD/7QCcUGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAIAcAmcAFGZMZVNrbnlWNDFxWDVJd0l1TGdoHAIoAGJGQk1EMDEwMDBhYzIwMzAwMDBlYzA1MDAwMGIyMDgwMDAwNjMwOTAwMDBmZDBhMDAwMDQ5MGUwMDAwYzkxMTAwMDA2NjEyMDAwMDJiMTMwMDAwNjgxNDAwMDBiMjE5MDAwMP/iAhxJQ0NfUFJPRklMRQABAQAAAgxsY21zAhAAAG1udHJSR0IgWFlaIAfcAAEAGQADACkAOWFjc3BBUFBMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD21gABAAAAANMtbGNtcwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACmRlc2MAAAD8AAAAXmNwcnQAAAFcAAAAC3d0cHQAAAFoAAAAFGJrcHQAAAF8AAAAFHJYWVoAAAGQAAAAFGdYWVoAAAGkAAAAFGJYWVoAAAG4AAAAFHJUUkMAAAHMAAAAQGdUUkMAAAHMAAAAQGJUUkMAAAHMAAAAQGRlc2MAAAAAAAAAA2MyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHRleHQAAAAARkIAAFhZWiAAAAAAAAD21gABAAAAANMtWFlaIAAAAAAAAAMWAAADMwAAAqRYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9jdXJ2AAAAAAAAABoAAADLAckDYwWSCGsL9hA/FVEbNCHxKZAyGDuSRgVRd13ta3B6BYmxmnysab9908PpMP///9sAQwAJBgcIBwYJCAgICgoJCw4XDw4NDQ4cFBURFyIeIyMhHiAgJSo1LSUnMiggIC4/LzI3OTw8PCQtQkZBOkY1Ozw5/9sAQwEKCgoODA4bDw8bOSYgJjk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5/8IAEQgAtAC0AwAiAAERAQIRAf/EABsAAQACAwEBAAAAAAAAAAAAAAAEBQECAwYH/8QAGgEBAAMBAQEAAAAAAAAAAAAAAAECAwQFBv/EABoBAQADAQEBAAAAAAAAAAAAAAABAgMEBQb/2gAMAwAAARECEQAAAfcAAAAMYhs0Q3a5lkSAAAAAAYcqOnHjvxX11ksbR0lCMkDn348tIm5iyO+mw0gAABhxoxw06eFv1aRLxPUlxrHRqhtjVDbFbXWX2Y/TktP2hTPcxyN4AA0g9o/j7Z2128bWv8NO9/8AR83x31FVWddfsaJJ8HbWkkWlkOXXRcpusVs3C28uLt1RYNdvoecBrtyhDxp5v53o9PmJL5bfNbytoPqObOrOsfTLSLM8DbTxON+qubKNFlbTY9vwaZx520pN12iS/oefI1hHkRqIFXc1fz/RMleV9TCm+d/Xqbor85u7z0nRXqy8TXArIwMZrNYhW1P6HurvOgT/AE88jrojSeNUKkuqn5/ok0s629/B3oni63qusPPvkZyOFo74qte2u2srHtZV97W2Pla7z4U31csjoq03wVvOTy8HfztlX+g9jHWy8td7RX6zrOHkpk20o8/z9JV2WVbIpbJOm2aNJx4HRLk6b/Q84SA511pGwmLT2zxt8yfN+l9zCisdrXSPMT+tmUkD1VWdeVj5Cqy30meJviVwsPQzzk7aAAMZEOJbR+e0WumvG2q50rG9YVlA571709z3ytS22/PmtvtvN9PJud1AAAAANI0xCp1tsYWqVoxmr2s9tIgTOmemuMkgAAAAAAAAAAAAAAP/xAAtEAABBAIABAUCBwEAAAAAAAABAAIDBAUREBITIBQhMDE0IjIVIyQlNUBQM//aAAgBAAABBQL/AANra2t/0i9c5K+orkK5CtOW3BCRA+q52lsuQaO8tC0Qmv8ATe7SHn6bgmu0gfQc7XZPZhriPJ1JDvtmu14UcooZerGUx3eSidnhesirBHWtXi4Fpw94sfwe9sbfz7yhqwwDsY7ukPZnJeazViENfKEG+Do1pOrXJ0Aw2nqe5DAhYtyoMupnMGpp0R2FO9+OU+f+NuFUkkrE/Ae0PD3tjbbyjpnVY59eCtPQx7woop4zwjPlxf7OcGiXJuc+BszQs1Hy3ONJnSqOcGtuG1ffXxdlifQvLlysKo2ZpSfaxZtU3VrUdlsfZJ7SRtlbk/op1pRPCspV8RB7cMXVNif0DMH5Tox9Vnvxl9lb87EMhqT8LWOhsGPCxgxRsiZ33LHSE7G15Uz7hxl9lkZOjJUYyavXlmqRxSMlb6Ni4GmasIYLQ6l5M+7i/wBllG7q4mdrW0B+itU+lN4mzXUV6tKgQex80ca8c15hjnussxMhr5V2oHMAuKLsKPk6RgkjrRsloY+19E/y1JWhmvnEwKzTlrxeAnX4Y0rH06/I0ALH/Gycoay3HyVqv1oqIaHZKOGQa6B3QisVX9eragtwTIfyKyXxeFD7ZrMMKpGxLBahZBXvnrO1oDzcO1wX2uIDhDIcdJvmyE1eGdNrOZd/XNV59o1utdX7i5VaskqgqQQLHfGykv0V4ek0nSibod0jOYAp7Wva1slCWCxHYYz+RWS+Hwp/9CQBBceYq9cQonSjbsj0JI9reuElRjnNdbrzNyldXbdeSp4ysE/KVGKO5OZPCTWExjY2k6TGFxA9J8Yci1zEHA8CA5Oq13LwVZNhiZwJAWy5RxaQHqEJ8QK6TgvzAucrnK29ckhTYAg3X9HS5VyrlWv8H//EACQRAAICAQQCAQUAAAAAAAAAAAABAhEgAxAhMRITMCIyQEFx/9oACAECEQE/Afn8a7LPJnkUmNVko0sKOCrQ1WGnH9jJu2LarLSEycbWFqK2fey6G2+j+iSPJPgfD2RLojKycLFDBuiHJPveXMROhahe1jmkOVmn0S73g7VElT3vD7Y4RdMaUkNVjGNcsnK8YyotSHpnrYtM+mJKd/ApNHsZ5v8AC//EAC0RAAICAQIEBAUFAQAAAAAAAAECAAMEERIQEyExBSAyURUiMEFhFCMzQENS/9oACAEBEQE/AfLuH0WYKNTHymbpXOWzepp+mT3nJK+louRZX6+oldq2DVfKzBRqZflc1vxK3LdFhLL3nMnMm1z9pzjS+olNotXcPJ4lf/mOGDSK69fuY6B10MOoOkNgqH5nLus+Yx6tv3mDfy30PbyGp8iwkRhtOkoOta8LGBsOkrrqq+aw9Yzcz0MJdZYDteNjug3jtKW31g8H9JmLq1oWZeOan/Ews0VjY8yfEEC6J3n541Vta20TNU07VX2mF/COBGomP8mT1lla2DRpf4aw6pGqdO4mkVGPYSrw+x+/SY+MtI6TxNtbAJirtqA451Zrs3iUWi1Aw4aCctPaBQO3BmCjUxAcm+Aacb6hau0yq18R9rdpXYtg1XyEgDUzKyjcdidph43JXU9/LfjrcOsam7GOqxPE2HrE+J1+0fxT/kT9/KMxsNaup7/QfGqfuJ8Ppi4dS9hAAO39H//EADsQAAEDAQQHBQQKAgMAAAAAAAEAAgMRBBIhMRATIjBBUWEjMlJxgSAzc5FAQlBiY3KCobHBJDRDotH/2gAIAQAABj8C+1sPp2G9x+k9o8BU1lPMe1R0mPIYrZs0pQfcczod6X/WyaE6UNLupRBFCEIJDsHLppLnGgCzMNn/AOzlsMHnx34j4NCjjbwCmpleVVHJzCqVrJPdDuN59Too51Xchiuys4aObytqaMeTVtuvHnTeS+aDAztaUvcFU6I1Q5IucQ1oVyI3I+fEr/Hgu/iSZrtbYfRYWuVYz6xvUY7gucaAIMs7MCaX3I66QPPQaL3iFfYiZ0RcTgF2cbtUMlW8xh+aqLVe9Vm537q5NEWu50WCbrLkodyCq3Pi08PauvFQqMbjeFAE2QcdFW99mWkEjs24ncsb9VtW16rWhtH5Ye3ZG/fqnl3+u95H5Tpvdx3MLblLh0CDGCgG4DG+9fgOnVWKMeLPnuLLLwa9SBwvMfI5Bzml9mJwPFqvMcCN1q4tuStOjfNVcb8rpG3nHzUTuAkuj+9xepW44FGDIYujPiCj6hRusrjE97qdFS02ckeNi2ZR5HBYY+xtyNHqqWeN8x6DBX5ZNXHXuM/9TGxtDW6xqDAaPc8U+ahiGUTC4+Z3DmHJwopIH7MtnJxGYUcEw1cl3D7yso6n+NBa+NpGr/tbDpGeTkXstkvqsbdIu0tEz/1JxMQc4PIq7FUAov1O/lMYMZL4o1OkkdV5c28eWKknP/KcPLh7ddDrTGO825IFG14vNuihUVa2hgBp4lRr6O8LsCnfC/vQ7zGmX4rltyCvLirsfZR3jtnPNC6Mb7ak5lCyN44vPIKgy3FEWkVBWrkxszjsu8KZ8MrtIw5ObDO9lGDPaWcEn7J1+BoGGIesLK31kWUEf7qbW2l+EhqGYVXZxivPiv1O/lNgjxmcQQEam9I7Fzue6oc0WuFQVrAHSw0pTi0K9G4EKT4Y0P02kfif0qnALUWVt5941ecm4ouJvyO7zzx0XjuqO0ayMmKTxNTpHsE4IpVuBW3ejP3mp4bMw+q9+z5r3t78oUxs9ncQ91QXYKtsmLh4G5K6xoA6aKu3nMacQD5rGFnyXuGLZjaPTRitkeqqc9/suWQK7hXcKwYs6LHH7X//xAApEAEAAgEDAwMFAQADAAAAAAABABEhMUFREGFxIIGRMKGxwfBAUNHh/9oACAEAAAE/If8AffRWV6L/AMCwyOiSuafzc8PzK+ZvLnNBZf1AjZ4ILXMKNJcuXL6J2jmqbbB+l7qC99Fy5fS5cuXLm4azTMs+hUmrDEuWh10N2Una9qASxsety45QfPTPi+aqMoh8s1Sppg+qomYh01GryGZ9Tlqt7ReyKR2lnHC3f1IsK1Y6hsnD+iVQzyyveW9HpcerZ9CHv7TC4wPzE+RgDSZnbjWAiUGVhk2+16B75ppkVen60VnsNsBAOFTrCs9CxFb9DW3+VBga6j5R0lq2vRrb3/M5TMnMKsGVjBu9JkjT5nia8HYx27UKh7p+d1s9BUoFAVq7TSwCGLl6scYa6M1MF1EvDUNyiEFrKeNMaq+7GvPEsRmSvMinAzuGKh4sxDLWtTWGa4jooYyVD3EPNQ6uGtx1OZWqCAm82b+Th36NWXm7jciKpKemUI289ulc+up1mGx3yoAAyws79M9IOFftEH6r6QEQRsdE6O8113PJALwSiCD0wQj6r/lp5WLTPijVa8mPQ0ddXpdvI8QxnuAuMyYBnLB7nufSoaMLbzylgvIdwOCBrPwsuHpHU2oaQyeQTtvKLNzX82QEUEtTyw0tSDtvSOMj3T4mgF8qA2gdm/QVfk48hLV8mZQlG807wd0YDzB2BDuuUzUqHQFqw6nEFhzmagYUchSnmLhFVRnoeRnzD0Z4Y6VmB5fkzTSFdzBsVexBvyVIvtaWGYVDgKmn/WUasdfc34lPyjZFMHaWeutvxxColD6GV47QbyS7MP2DoyuDADkxqMBadyaTHzFaW7ifZn2zo/k89dPxDCl2HK9pRgsdR5aG3vLxFM68m7DzDHjf7YAAoFBBWbENHpsImbo6QyQKR3l1nyX4YiiiDHukMyXNZPeX3pHm0zK/OBcG74sreKaeF4fKy4oKIMKqMzIB5c/Kfxd0BwGntTq9pZLz3T/qVO+01TWHpYUEvbfeC3xkZ8/T2vHJPzTo8k1X8X0/B/PXDzv2RkoGqxt2IiV8y7Huh/4gC2P8SQV60hG94Nabzz09unt+SFDG1wHaLafGYjKlqg7ogzHzxwjNNGqxipYPFHIQj0BD167E+MRxKj6KQjJND8cx108PQyiOy4hbGAdPgn2j+gG0E03vJa1OTKPqCzVyOvPDmc0lOvzdBu2PLDVjwIRvJ3h7IH16iZXiV4lP+Cf/2gAMAwAAARECEQAAEPPPOPv8tPPPPPPF3Vgzh7PPPPDwFHg22oy/POHEg4+1nIolPOq4acEPilFVPATYLgt/B/2qPF6dJkvK0ALLPPOuSnr7nt/bvPFyDCIIL4KfPPLANuZXsDxPPPPLKqC6wfPPPPPPPPPPPPPPPP/EACERAQACAgICAgMAAAAAAAAAAAEAERAxICEwUUBBYXGB/9oACAECEQE/EONPhBWiAhU0Yu2wjrdRVTxBWifvolbhTqVhYgKmO6eH3MOkiRuDZcP4TQJc6nceuAAMGyGlgULiFDqBWjGFkEe0NhjaVLwhEVka7cGANsfdfc34JuERWQncC6lyhNJGfcO0dtz3KLVm3uLeAVojXAW4l6Iip4ArRK8LfWuKPqB6YLpn5p7WUMfqa8GmcKv3Lv4P/8QAJxEBAAIBAgUDBQEAAAAAAAAAAQARITFBECBRYYFxkaEwscHR4UD/2gAIAQERAT8Q5FqdyCOn0FC0EVpx1Y5bvYnce8MhzzNGdwlwOV29BFz4GhFDIzFFOBkHZ+E21dzaDeRSxO7GAWbkYSuXqTEM/b/Y5DQ7rU1tX0v9RhbLitFwh8Xq6Q1CPchOOhwbHqsOovQukvWd76/MXsPgfmG83UTvmcHSHRjbOLuo6d2k2y7PSIXtb9INjbMVdZcE5ViCMYRrfwuCYx1JFZWRNynzHKY8S3SK1ZG7NO/6lGzd3eAJsRWunE3pOfM85HrwUKYs2n2JoCuDtqCWDZb8EoUcX/gYxDu/ZLXWcjpKCEf7oW6NeWu69mZ7V2/MJq30xCjKlhXvsWrmvYIbqfZzoOsUsbjbpG792A1/hf/EACgQAQACAQQBBAICAwEAAAAAAAEAESExQVFhcRCBkaEgsTDBQNHw4f/aAAgBAAABPxD/ADrjCCUb/c7D5geYFl/zXBJgxt6jlfAXP/Yalute8Vw2p7GGne4g4CncNsRhb+NYbl9oqh5Q70gCgHj8Qc6zWQPJF8g6gNYWGn8K1BFGYWyU/cECjB+Av8gC2Fbu46Fs5gCz81qFg12irK5YwBCSAku2/EGYRWqhYr5hIwLEbEly/URi+z9JAx2e83tUsxjjo9+IMnmKDY2lh+RMsdlptNR6VgH2N3d6NZktJNHBbXwRSxBqUakYY+1vhPDLly0/5qAl62nIK5HZAW753OVRbd+Zr6dGVQ6kG/wWptXX1GyYMDKvufqoWAMa3Ra+7Kz1Us0sAfuLySBNk0m8z5xo/ZAwHUOANWEpUn1m1+iLcyUeh2vg0lXsyNTmkdAfP+zL0EzQvtNpQuzKh/CpS2Q9DWKFsAPhK0p3DQVhrfUR88jVXVhOIwTxGcKwltNnqXEzOoCIi2KFLqtPEqs8Ub7A6e1xyhOqqP1B5I31/bLJcxYDob+Y49Kb4h62jqMwQvQOWGrpobJrBp8wI2ESd/PpoOceUw/o9RabzS695Of7h4Fq10EMZtGnyqzMo3p7BYxGKZ0GO47hCHzmPBCFU9m9GBCCqwsHZqXGaCZ1rp5nHSef7juVqNHrQ5e+421g2X1EYlKyg3gPEVQ+GcD59BVsJmv/AEPtHDAaRMj6LGAIMIyDtng9o4ULHkl4rb10iruvv6GK80XRGnYUS2mK1hwNY68yafXX9LOqyh3hiyrGBdXgb/6oTYVosTkl1BxrQynzyQGhbqX8uYCGsL7eXuKmIT8WGwgLUK8ALxyxCnV4CUnlZ/aaPj1GG5DdShVrPMZ+ovLRHImCd7zHclUCM9QSbYXTpNn+C/S3MCcoUIfqWCKCy64NjYhKEJ9lZPlr2n94bfR62U7qafWIQAOBhvX0lJt0gsbB6IpgCCxs1N4tg6rVOz7PuK6PNf7dn1Km37tHzLg5uQ+pps+lPDEgE4x+NY21WBBveIhhVxtYhPMOkqS4DryXVe2Bw6ZAtnBzLUVwyqUL20vv6eZ6gx62KcX4IAl2B2RyGSVqAdORmAHS9Ljlckzo/wCuj+5WK2dodlmuTAXjeo55GUPmU0T2EwH9y2T6Yw4F3kovxBSPrEChr1UBAXQQ+oYNZEl2tals7ZZAocBbqH3rGVpgjJ+8C/eWLvtO0Q9RcagWu/aADQcyjBkaIV7OIjLkzzTCyMP4fgYZvatlbsoVGAXOHJ8TLqgqD/q2yoGSFHmTfKP9yvU9Xe4DawmqqOmpW+2v4TL1Mz7018aErevC3Fh5CiFuKBoBoSuc5XzKw/E3GImBrffEakQbAdSDs3hmz6owMfDYmWMrBTR08QyTTFuopXbUp0B5+mKQZkoWiB0Sa2dbX9E2IvIn6JcE9pfDhnN6TMl6hd5WZpwqCDjXSzr8pYQy/VeOmgTQMpocscnJZXuCj8RHBWdniEeDe4cwBV09iSoZrJbtByQMtag0vGoMF7YP7ypgnH9UNCVC3Fg/lEWoWigPMqgilpAG91MEzE5rcHHSMXoPuU8p+Agg/OyVpYciakws0Tb/AKMuoz1Jv/oGH0xMCNK8XmbE3aS+S4NKqDbhtDSUrgzRhzBYUNYdOqs305jboLEq6U1m16dCHmStDVgcKrw/+oJFQP4LCIQGPY0bnJ4Yr9HsudEaH9p2gyp+o2tju0pcFojcvFbcSsF7YPsBw/ogWK2upBGCB/ElwDSCtL7TSSeBFwmcik/pAM4/mIacg0HOJCLuVWw6gEE/mSJYrYiuydKA7ECbQKlf5/8A/9k=';

                            //console.log(that.avatar_crop_data)

                            //that.$refs.avatar_url.style.backgroundImage = "url('"+e.target.result+"')";

                            that.disable_button_update_avatar = false;
                        };

                        if (/\.(jpe?g|png|gif)$/i.test(image.name)) {
                            reader.readAsDataURL(image);
                        }

                        this.$nextTick(function() {
                            $('#profileUploadModal').modal('hide');
                            //$('#cropAvatarModal').modal();

                            $('#cropAvatarModal').on('shown.bs.modal', function() {
                                if (that.cropper != null) {
                                    that.cropper.destroy();
                                }
                                that.cropper = new Cropper(
                                    document.getElementById('image-crop'), {
                                        aspectRatio: 1,
                                        crop(event) {
                                            //console.log(event);
                                        }
                                    });
                            });
                            $('#cropAvatarModal').modal('show');
                        });

                        break;
                }
            },

            selectAvatar(avatar) {
                this.user.avatar_id = avatar.id;
                this.user.avatar_img = avatar.url;

                this.$refs.avatar_url.setAttribute("src", avatar.url)
                //this.$refs.avatar_url.style.backgroundImage = "url('" + avatar.url + "')";

                this.disable_button_update_avatar = false;
            },

            selectEmoticon(emoticon) {
                console.log(emoticon.url);
                this.user.emoji_id = emoticon.id;
                this.user.emoji_url = emoticon.url;

                this.$refs.emoticon_url.setAttribute("src", emoticon.url);

                this.disable_button_update_avatar = false;
            },

            updateAvatar() {
                const that = this;
                const formData = new FormData();

                formData.append('avatar_id', this.user.avatar_id);
                formData.append('avatar_img', this.user.avatar_img);
                formData.append('emoji_id', this.user.emoji_id ? this.user.emoji_id : 0);
                // formData.append('emoji_id', this.user.emoji_id);
                formData.append('type', this.user.type);
                formData.append('extension_file', this.user.extension_file);

                that.$store.commit("setLoading", true);
                if (this.user.avatar_id && !this.user.emoji_id) {
                    this.user.type = 0;
                } else if (!this.user.avatar_id && this.user.emoji_id) {
                    this.user.type = 1;
                } else {
                    this.user.type = 2;
                }
                updateAvatarParent({
                    avatar_id: this.user.avatar_id,
                    avatar_img: this.user.avatar_img,
                    emoji_id: this.user.emoji_id ? this.user.emoji_id : 0,
                    type: this.user.type,
                    extension_file: this.user.extension_file,
                    //is_raw: true
                }).then((response) => {
                    that.$store.commit("setLoading", false);

                    that.disable_button_update_avatar = true;

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }

                    const time = new Date().getTime();

                    that.user_info.avatar_id = response.data.results.avatar_id;
                    that.user_info.avatar_url = response.data.results.avatar_url + '?v=' + time;
                    that.user_info.emoji_id = response.data.results.emoji_id;
                    that.user_info.emoji_url = response.data.results.emoji_url;

                    console.log(" that.user_info.emoji_url: ",  that.user_info.emoji_url);

                    $('#uploadAvatarModal').modal('hide');
                }).catch((response) => {
                    that.$store.commit("setLoading", false);

                    that.disable_button_update_avatar = true;

                    console.error(response)
                });
            },

            doTest(){
                $('#popupUpgradeAccount').modal('hide');
                $('#placementModal').modal('show');
            },

            onSubmit(e) {
                const that = this;
                if (that.is_valid == false) {
                    return false;
                }
                const formData = new FormData();

                formData.append('fullname', this.user.fullname);
                //formData.append('birthday', this.user.birthday);
                formData.append('birthday', moment(this.user.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD'));
                formData.append('relationship', this.user.relationship);
                formData.append('phone', this.user.phone);
                formData.append('email', this.user.email);
                //formData.append('grade', this.user.grade);

                that.$store.commit("setLoading", true);

                updateParentProfile(formData).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }
                    that.user_info.fullname = response.data.results.fullname;
                    that.user_info.relationship = response.data.results.relationship;
                    that.user_info.phone = response.data.results.phone;
                    that.user_info.email = response.data.results.email;
                    that.user_info.birthday = moment(response.data.results.birthday).format('DD/MM/YYYY');
                    that.key_change_info = that.getKeyChangeInfo(that.user_info);
                    //location.reload();
                }).catch((response) => {
                    that.$store.commit("setLoading", false);

                    console.error(response)
                });

                e.preventDefault();
            },

            updateContact(e) {
                const that = this;
                if (that.is_valid == false) {
                    return false;
                }
                const formData = new FormData();

                formData.append('phone', this.user.contact_user.phone);
                formData.append('email', this.user.email);
                formData.append('country_id', this.user.contact_user.country_id);
                formData.append('city_id', this.user.contact_user.city_id);
                formData.append('ward_id', this.user.contact_user.ward_id);
                formData.append('address', this.user.contact_user.address);

                that.$store.commit("setLoading", true);

                updateContact(formData).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }

                    that.user_info.fullname = response.data.results.fullname;

                    //location.reload();

                    //alert('Ok')
                }).catch((response) => {
                    that.$store.commit("setLoading", false);

                    console.error(response)
                });

                e.preventDefault();
            },

            updateSchoolInfo(e) {
                const that = this;
                if (that.is_valid == false) {
                    return false;
                }
                const formData = new FormData();

                formData.append('phone', this.user.contact_user.phone);
                formData.append('email', this.user.email);
                formData.append('country_id', this.user.contact_user.country_id);
                formData.append('city_id', this.user.contact_user.city_id);
                formData.append('ward_id', this.user.contact_user.ward_id);
                formData.append('address', this.user.contact_user.address);

                that.$store.commit("setLoading", true);

                updateContact(formData).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }

                    that.user_info.fullname = response.data.results.fullname;

                    //location.reload();

                    //alert('Ok')
                }).catch((response) => {
                    that.$store.commit("setLoading", false);

                    console.error(response)
                });

                e.preventDefault();
            },

            onLogout(e) {
                this.$store.dispatch('logout').then(() => {
                    window.location.href = "/login";
                });
                localStorage.removeItem('grade');
                e.preventDefault();
            },
            changePassword() {
                $('#ChangePasswordPopup').modal('show');
            },
            changeNewPass() {
                const that = this;
                const formData = new FormData();

                if (that.new_password.length < 8) {
                    that.errors.new_password = 'the_new_password_must_be_at_least_8_characters';

                    that.showError(that.errors.new_password);

                    return false;
                }
                formData.append('old_pass', that.current_password)
                formData.append('new_pass', that.new_password);
                formData.append('confirm_pass', that.confirm_password);

                that.$store.commit("setLoading", true);

                changeNewPassword(formData).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        that.showError(response.data.msg);

                        return;
                    }
                    // alert('Ok');
                    $('.modal').modal('hide');
                    $('#formSuccessModal').modal('show');
                    that.resetPasswordState();
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },
            resetPasswordState() {
                this.current_password = '';
                this.new_password = '';
                this.confirm_password = '';
            },
            strengPassword(password) {
                let str1 = 0;
                let str2 = 0;
                let str3 = 0;
                (password.length >= 8) ? str1 = 1: str1 = 0;
                (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) ? str2 = 1: str2 = 0;
                // if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)){this.strength += 1}
                (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) ? str3 = 1: str3 = 0;
                this.strength = str1 + str2 + str3;
            },
            eventValid({ target }) {
                this.is_valid = true;
                switch (target.name) {
                    case 'fullname':
                        this.errors.fullname = '';
                        if (this.user.fullname.length > 50) {
                            this.errors.fullname = "Fullname max 50 characters.";
                            this.is_valid = false;
                        }
                        if (this.regexSpecialChar(this.user.fullname)) {
                            this.errors.fullname = "Fullname cannot contain special characters";
                            this.is_valid = false;
                        }
                        break;
                }
                return this.is_valid;
            },
            regexSpecialChar(txt) {
                var specialRegex = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;
                if (txt.match(specialRegex)) {
                    return true;
                }
                return false;
            },
        }
    }
</script>

<style scoped>
    /* .modal-dialog.popup{
        margin-top: 12%;
    } */
    .save-parent{
        background: #98C93C;
        border-radius: 8px;
        color: #fff;
        font-weight: 700;
        width: 100% !important;
    }
    input::-webkit-outer-spin-button,   
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }
</style>
